import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  Divider,
  Paper,
  IconButton,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  CircularProgress,
} from "@mui/material";
import {
  Close as CloseIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Print as PrintIcon,
  Map as MapIcon,
  Add as AddIcon,
  Bookmark as BookmarkIcon,
  LocationOn as LocationOnIcon,
  ExpandLess,
  ExpandMore,
  AdsClick as AdsClickIcon,
} from "@mui/icons-material";
import PinDropIcon from "@mui/icons-material/PinDrop";

/** measure tool drawer panel */
export default function MeasureToolPanel(ctx) {
  const {
    measureType,
    setMeasureType,
    measureUnit,
    setMeasureUnit,
    measureAreaUnit,
    setMeasureAreaUnit,
    measurements,
    setMeasurements,
    isMeasuring,
    startMeasurement,
    stopMeasurement,
    clearMeasurements,
    mapInstanceRef,
    measureLayerRef,
    onCloseTool,
  } = ctx;

  return (
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh - 160px)",
                    // overflow: "hidden",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
                  >
                    Measurement Tools
                  </Typography>

                  {/* Measurement Type */}
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Measurement Type
                    </Typography>
                    <Select
                      fullWidth
                      size="small"
                      value={measureType}
                      onChange={(e) => {
                        setMeasureType(e.target.value);
                        if (isMeasuring) stopMeasurement();
                      }}
                      sx={{ bgcolor: "white" }}
                    >
                      <MenuItem value="LineString">📏 Distance</MenuItem>
                      <MenuItem value="Polygon">📐 Area</MenuItem>
                    </Select>
                  </Box>

                  {/* Unit Selector */}
                  {measureType === "LineString" ? (
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{ mb: 0.5, fontWeight: 500 }}
                      >
                        Distance Unit
                      </Typography>
                      <Select
                        fullWidth
                        size="small"
                        value={measureUnit}
                        onChange={(e) => setMeasureUnit(e.target.value)}
                        sx={{ bgcolor: "white" }}
                      >
                        <MenuItem value="meters">Meters (m)</MenuItem>
                        <MenuItem value="kilometers">Kilometers (km)</MenuItem>
                        <MenuItem value="feet">Feet (ft)</MenuItem>
                        <MenuItem value="miles">Miles (mi)</MenuItem>
                      </Select>
                    </Box>
                  ) : (
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{ mb: 0.5, fontWeight: 500 }}
                      >
                        Area Unit
                      </Typography>
                      <Select
                        fullWidth
                        size="small"
                        value={measureAreaUnit}
                        onChange={(e) => setMeasureAreaUnit(e.target.value)}
                        sx={{ bgcolor: "white" }}
                      >
                        <MenuItem value="sqmeters">Square Meters (m²)</MenuItem>
                        <MenuItem value="sqkilometers">
                          Square Kilometers (km²)
                        </MenuItem>
                        <MenuItem value="hectares">Hectares (ha)</MenuItem>
                        <MenuItem value="acres">Acres (ac)</MenuItem>
                      </Select>
                    </Box>
                  )}

                  {/* <Divider sx={{ my: 2 }} /> */}

                  {/* Instructions */}
                  {/* <Box
                    sx={{ mb: 2, p: 1.5, bgcolor: "#e3f2fd", borderRadius: 1 }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "11px",
                        color: "#1976d2",
                        display: "block",
                        mb: 0.5,
                      }}
                    >
                      {measureType === "LineString"
                        ? "📏 Click points on map to measure distance"
                        : "📐 Click points on map to measure area"}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ fontSize: "10px", color: "#666" }}
                    >
                      Double-click to finish measurement
                    </Typography>
                  </Box> */}

                  {/* Measurements List */}
                  {/* Measurements List */}
                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      mb: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, fontWeight: 500, flexShrink: 0 }}
                    >
                      Measurements ({measurements.length})
                    </Typography>
                    <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                      {measurements.length === 0 ? (
                        <Typography
                          variant="caption"
                          sx={{ color: "#999", fontSize: "11px" }}
                        >
                          No measurements yet
                        </Typography>
                      ) : (
                        measurements.map((measurement, index) => (
                          <Paper
                            key={measurement.id}
                            sx={{
                              p: 1,
                              mb: 1,
                              bgcolor: "#f5f5f5",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box>
                              <Typography
                                variant="caption"
                                sx={{ fontWeight: 600, fontSize: "11px" }}
                              >
                                {measurement.type === "LineString"
                                  ? "📏 Distance"
                                  : "📐 Area"}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "13px",
                                  color: "#1976d2",
                                  fontWeight: 600,
                                }}
                              >
                                {measurement.value}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", gap: 0.5 }}>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  if (
                                    !measurement.olFeature ||
                                    !mapInstanceRef.current
                                  )
                                    return;
                                  const geom =
                                    measurement.olFeature.getGeometry();
                                  if (!geom) return;
                                  const view = mapInstanceRef.current.getView();
                                  const geomType = geom.getType();
                                  const extent = geom.getExtent();
                                  if (
                                    extent &&
                                    extent.every((v) => isFinite(v))
                                  ) {
                                    const [minX, minY, maxX, maxY] = extent;
                                    if (maxX - minX < 1 && maxY - minY < 1) {
                                      view.animate({
                                        center: [
                                          (minX + maxX) / 2,
                                          (minY + maxY) / 2,
                                        ],
                                        zoom: 15,
                                        duration: 800,
                                      });
                                    } else {
                                      view.fit(extent, {
                                        padding: [100, 100, 100, 100],
                                        duration: 800,
                                      });
                                    }
                                  }
                                }}
                                sx={{
                                  color: "#1976d2",
                                  "&:hover": { bgcolor: "#e3f2fd" },
                                }}
                                title="Zoom to measurement"
                              >
                                <SearchIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  if (
                                    measurement.olFeature &&
                                    measureLayerRef.current
                                  ) {
                                    measureLayerRef.current
                                      .getSource()
                                      .removeFeature(measurement.olFeature);
                                  }
                                  setMeasurements(
                                    measurements.filter(
                                      (m) => m.id !== measurement.id,
                                    ),
                                  );
                                }}
                                sx={{ color: "#f44336" }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Paper>
                        ))
                      )}
                    </Box>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  {/* Action Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      flexShrink: 0,
                      mb: 2,
                    }}
                  >
                    {!isMeasuring ? (
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<MapIcon />}
                        onClick={startMeasurement}
                        sx={{
                          bgcolor: "#1976d2",
                          "&:hover": { bgcolor: "#115293" },
                        }}
                      >
                        Start Measuring
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<CloseIcon />}
                        onClick={stopMeasurement}
                        sx={{
                          bgcolor: "#ff9800",
                          "&:hover": { bgcolor: "#f57c00" },
                        }}
                      >
                        Stop Measuring
                      </Button>
                    )}

                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={clearMeasurements}
                        disabled={measurements.length === 0}
                        sx={{ borderColor: "#ff9800", color: "#ff9800" }}
                      >
                        Clear All
                      </Button>

                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        onClick={() => {
                          stopMeasurement();
                          onCloseTool("measure");
                        }}
                        sx={{ borderColor: "#f44336", color: "#f44336" }}
                      >
                        Close
                      </Button>
                    </Box>
                  </Box>
                </Box>
  );
}
